import ___default from "lodash";
import EnvironmentService from "../services/EnvironmentService.js";
import { ErrorInfoService } from "../services/ErrorInfoService.js";
import "../models/index.js";
import { ApiErrorType } from "../models/ErrorModels.js";
const parseVNextApiError = (error) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j;
  if (typeof error !== "object" || !error) {
    return void 0;
  }
  if (typeof error.code !== "string" && typeof error.Code !== "string" || typeof error.message !== "string" && typeof error.Message !== "string") {
    return void 0;
  }
  if (EnvironmentService.enableIApiErrorExceptionHandlingToCT()) {
    const errorMessage = (_b = (_a = error == null ? void 0 : error.message) != null ? _a : error == null ? void 0 : error.Message) != null ? _b : "No error information is present";
    const errorCode = (_c = error == null ? void 0 : error.code) != null ? _c : error == null ? void 0 : error.Code;
    return {
      code: errorCode,
      message: ErrorInfoService.modifyErrorMessage(errorCode, errorMessage),
      target: typeof error.target === "string" || typeof error.Target === "string" ? (_d = error.target) != null ? _d : error.Target : void 0,
      // @ts-ignore
      details: Array.isArray(error.details) || Array.isArray(error.Details) ? ___default.map((_e = error.details) != null ? _e : error.Details, (d) => parseVNextApiError(d)) : void 0,
      innererror: parseApiInnerError(error)
    };
  }
  return {
    code: (_f = error.code) != null ? _f : error.Code,
    message: (_h = (_g = error == null ? void 0 : error.Message) != null ? _g : error == null ? void 0 : error.message) != null ? _h : "No error information is present",
    target: typeof error.target === "string" || typeof error.Target === "string" ? (_i = error.target) != null ? _i : error.Target : void 0,
    // @ts-ignore
    details: Array.isArray(error.details) || Array.isArray(error.Details) ? ___default.map((_j = error.details) != null ? _j : error.Details, (d) => parseVNextApiError(d)) : void 0,
    innererror: parseApiInnerError(error)
  };
};
const parseApiInnerError = (error) => {
  var _a, _b, _c;
  const innerError = (_b = (_a = error == null ? void 0 : error.innererror) != null ? _a : error == null ? void 0 : error.innerError) != null ? _b : error == null ? void 0 : error.InnerError;
  if (typeof innerError !== "object" || !innerError) {
    return void 0;
  }
  if (typeof innerError.code !== "string" && typeof innerError.Code !== "string") {
    return void 0;
  }
  return {
    code: (_c = innerError == null ? void 0 : innerError.code) != null ? _c : innerError == null ? void 0 : innerError.Code,
    innerError: parseApiInnerError(innerError)
  };
};
const getDisplayError = (error) => {
  var _a, _b, _c, _d;
  if (EnvironmentService.enableIApiErrorExceptionHandlingToCT()) {
    const errorMessage = (_a = error == null ? void 0 : error.message) != null ? _a : "No error information is present";
    const errorCode = error == null ? void 0 : error.code;
    const displayError = ErrorInfoService.modifyErrorMessage(errorCode, errorMessage);
    if (((_b = error == null ? void 0 : error.details) == null ? void 0 : _b.length) > 0) {
      return `${displayError}: [${___default.map(error.details, (d) => getDisplayError(d)).join(", ")}]`;
    }
    return displayError;
  }
  if (((_c = error == null ? void 0 : error.details) == null ? void 0 : _c.length) > 0) {
    return `${error.message}: [${___default.map(error.details, (d) => getDisplayError(d)).join(", ")}]`;
  }
  return (_d = error == null ? void 0 : error.message) != null ? _d : "No error information is present";
};
const parseError = (r) => {
  var _a, _b, _c;
  const error = (_c = (_a = r == null ? void 0 : r.responseJSON) == null ? void 0 : _a.Error) != null ? _c : (_b = r == null ? void 0 : r.responseJSON) == null ? void 0 : _b.error;
  const apiError = parseVNextApiError(error);
  if (apiError === void 0) {
    return {};
  }
  return {
    displayError: getDisplayError(apiError),
    rawError: apiError,
    typeOfRawError: "IApiError"
  };
};
const getApiErrorType = (status) => {
  if (status === 0) {
    return ApiErrorType.TimeoutOrCancelledError;
  } else if (status >= 400 && status < 500) {
    return ApiErrorType.UserError;
  } else if (status >= 500) {
    return ApiErrorType.SystemRetryableError;
  }
  return ApiErrorType.UnknownError;
};
export {
  getApiErrorType,
  getDisplayError,
  parseApiInnerError,
  parseError,
  parseVNextApiError
};
//# sourceMappingURL=ErrorUtils.js.map
